module.exports = __webpack_public_path__ + "img/bodyimg.6eefe69b.png";